import { RootState } from '../../../store';
import CartItemChangeSet from '../modification/CartItemChangeSet';
import CartItemChangeType from '../modification/CartItemChangeType';

export default function remove(state: RootState, id: string): CartItemChangeSet {
  if (!state.session.content.cartItems.some(i => i.id === id)) return [];

  return [{ type: CartItemChangeType.Remove, id }];
}
